<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <el-row :gutter="10">
      <el-col :lg="10">
        <div>
          <fieldset class="margin-top-2 padding-1" style="height: calc(100vh - 550px)">
            <legend>数据传输监控展示</legend>
            <ve-line :data="DataMgr.chartData" :settings="DataMgr.chartSettings" height="calc(100vh - 550px)"></ve-line>
          </fieldset>
        </div>
      </el-col>
      <el-col :lg="14">
        <fieldset class="margin-top-2 padding-1" style="height: calc(100vh - 550px)">
          <legend>传输流程监控展示</legend>
          <div id="show" style="height: 100%;width: 100%"></div>
        </fieldset>
      </el-col>
    </el-row>

    <div>
      <el-drawer
        direction="ltr"
        :before-close="handleDrawerClose"
        :visible.sync="drawer"
        :with-header="false">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index">
            {{ activity.content }}
          </el-timeline-item>
        </el-timeline>
      </el-drawer>
    </div>
  </div>
</template>

<script>
  import EasyConfigApi from "@/api/basics/EasyConfigApi";
  import EnvironmentApi from "@/api/dashboardmgr/EnvironmentApi";
  import config from "cnetong-core-frontend/base/config";
  // 配置页面

  let chartDefaultData = {
// 图形大小
    linePointShow: false,// 线上的点 动不动
    ontPeriod: 5,// 第一个点的移动速度
    twoPeriod: 7,// 第二个点的移动速度
    symbolSizeOutDir: [60, 50],// 文件夹大小
    symbolSizeInDir: [60, 50],// 文件夹大小
    symbolSizeClient: [90, 70],// 客户端大小
    symbolSizeMQ: [80, 50],// MQ大小
    symbolSizeMQInQUE: [70, 40],// MQQUE大小
    symbolSizeMQOutQUE: [70, 40],// MQQUE大小
    // 图形字颜色
    lableColorClient: "#000000",
    lableColorOutDir: "#000000",
    lableColorInDir: "#000000",
    lableColorInQue: "#000000",
    lableColorOutQue: "#000000",
    lableColorMQ: "#000000",
    // 连线颜色
    lineColorOutDir_Client: "#12b5d0",
    lineColorInDir_Client: "#12b5d0",
    lineColorClient_InMQ: "#12b5d0",
    lineColorClient_OutMQ: "#12b5d0",
    lineColorMQ_OutQ: "#12b5d0",
    lineColorMQ_InQ: "#12b5d0",
    // 提示
    clientTitle: "运行正常",
    mqTitle: "运行正常",
    inqueTitle: "运行正常",
    outqueTitle: "运行正常",
    indirTitle: "运行正常",
    outdirTitle: "运行正常",
    localData: {"name": "DIR", "connconf": {}, "connstat": true, "conninfo": "连接异常信息", "havecs": true, "csstat": true, "csinfo": "消费者信息", "havepd": true, "pdstat": true, "pdinfo": "生产者信息"},
    transData: {
      "name": "RabbitMQ",
      "connconf": {"host": "192.168.2.1"},
      "connstat": true,
      "conninfo": "连接异常信息",
      "havecs": true,
      "csstat": true,
      "csinfo": "消费者信息",
      "havepd": true,
      "pdstat": true,
      "pdinfo": "生产者信息"
    },
  };

  export default {
    name: "TransChartShow",
    components: {},
    computed: {},
    data() {
      return {
        t1: "",
        t2: "",
        host: document.domain,
        port: window.location.port,
        activities: [{
          content: new Date(),
        }],
        drawer: false,
        charts: "",
        chart: Object.assign({}, chartDefaultData),
        //  接收的票数
        sqps: 0,
        // 发送的票数
        pqps: 0,
        // 异常数量
        exceptions: 0,
        // 阻塞数量
        blocknum: 0,
        // 警告数量
        warnnum: 0,
        DataMgr: {
          chartData: {
            columns: ["时间", "接收(票)", "发送(票)"],
            rows: []
          },
          chartSettings: {
            legend: {
              height: "41%"
            },
          }
        },
        flowMgr: {
          chartData: {
            columns: ["时间", "接收(M)", "发送(M)"],
            rows: []
          },
          chartSettings: {}
        },
      };
    },
    mounted() {
      this.drawLine();
      this.initWebSocket();
    },
    watch: {
      // 系统出现异常和阻塞就自动去检测一下
      exceptions: function () {
        this.basicsEnvironmentalTesting();
      },
      blocknum: function () {
        this.basicsEnvironmentalTesting();
      },
      sqps: function () {
        // 动态判断线上的点动不动
        this.pointShow();
      },
      pqps: function () {
        // 动态判断线上的点动不动
        this.pointShow();
      }
    },

    methods: {
      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        this.charts = this.$echarts.init(document.getElementById('show'));
        // 绘制图表
        this.charts.setOption({

          // backgroundColor: "#000",
          xAxis: {
            show: false,
            type: "value"
          },
          yAxis: {
            show: false,
            type: "value"
          },
          tooltip: {},
          series: [{
            type: "graph",
            zlevel: 5,
            draggable: false,
            coordinateSystem: "cartesian2d", //使用二维的直角坐标系（也称笛卡尔坐标系）
            symbol: "rect",
            symbolOffset: ["15%", 0],

            label: {
              normal: {
                show: true
              }
            },
            data: [
              {
                name: "数据交换客户端",
                tooltip: {
                  formatter: this.chart.clientTitle
                },
                x: 300,
                y: 300,
                value: [300, 300],
                fixed: false,
                symbol: 'image://data:image/png;base64,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',
                symbolSize: this.chart.symbolSizeClient,
                label: {
                  color: this.chart.lableColorClient,
                  position: 'bottom',
                },
                category: 1,
              },
              {
                name: "MQ",
                tooltip: {
                  formatter: this.chart.mqTitle
                },
                x: 600,
                y: 300,
                value: [600, 300],
                fixed: true,
                symbol: 'image://data:image/png;base64,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',
                symbolSize: this.chart.symbolSizeMQ,
                label: {
                  color: this.chart.lableColorMQ,
                  position: 'bottom',
                },
                category: 1,
              },
              {
                name: "接收文件夹",
                tooltip: {
                  formatter: this.chart.indirTitle
                },
                x: 0,
                y: 150,
                value: [0, 150],
                fixed: true,
                symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAE4UlEQVRoge2Zf0zUdRjHX5/v3QmKIqFwZsNDILClVubvTUtX6JRcze1ms9xsmK6i3KzmRiosaqvpWq6RiYmVrg3UVWYNJ5LZDydqMpYKioA/IMBTj4Ih3Pf79Mdxx+HADndwtN37r+eez/N5nvf7+/k8z753ByGEEEIIwYQa6IKH1hwXj33LcdlsL7TrO1K+8foiK9rNdux6pu1Lr6+yNtxciF1fFLPlfUReV8LHBx1vZgJoA0sfAKfHiLKOtQIgNHh8f6eEWd0uqfP4UuJa4wGUSAYQIYoMz1owBDR5DNHN9wMoRZXHZ4gkAijUaW+c0pa7DbYq+EdEtnrWzANAuDuEChRJAJqb7CmBcmA2gKaxCDgmij1KSANAsT7T9tXh92pfzAQyfdN1EyA7iUPjIyAVGOEnoWy1kiy/BShOA4sBDKUWAwVKyX4RtRpAhOX58SXZtTVHCzpsCeuAqcBQkMPvxH/xocul7a66GlZdiF0HnyvUSf4MsNRv8m5CmyTffwEi2mHvViGtJKvEfGVM1BGgvtMdZ4Q1Z2SRZSiwg7c/hoqoTSaTXEi2tbk8Obp6wP3ko/0mfo8inDdqfgWudX6Mbq8PX5r10zwXwkZPjCA5Ox78dm5O7YpqBbOAk73l823i1Hug3gU/RdgL7Tqw07tNqZyTL5+0RFa25yuktNM9BI29n0/YPyundkW1pfbSDJQsQ3GALvGdZTshuxAsFrDGwvAI0PpvQHXcHs4vBZtxdYQDkDz9a2wTi2i5MZLvNr1G6y33DTaZdYkZV5XfdG7aqytr5rX1lKtLwB6LkBAPJlO/EfdFTfkiLpTa3SQ0nSkLNxM95hyOmrEc2rLSKwLAZNYbdZd5FwYHlcbFERW3G+x3NjHW2AEjD2B7uIjIUTUAiGGi/MgrtDbHMiq+jiXZnxCTeMUbq7tMsSBvo8lRQa41pwzpoYmHRwwYeXA/9cnzc7GEtQDQ3jaCE99v4OZfKUREO3lmYy5z0vcx7D7n3fN4DDkxQe4W2F9wNiZxqugt9I4wADSTi6THC4l7qBjN5EIMjfqzCfz4wapPQSYDicCY9Ipn1aAQANB83UZZ8Ru0tXRN8aGRjSRN2Yd1fClKGajp53t88RwUAgBut0ZRVpyBsymxm98S1sLouDLqLsxahkiZxpD6p7dP9d6rQSMA3M1c++cCqs8s8Y7Y3pC6baaCYLzM3QVK04mf9AMPJP/M5bNPUVc5t9u16nGPxxgMJ3AnRDScTQk4rk3k0pnnDiiRZBGsKKI8JzCoBfiityYOxheagCIkINgI6BSKzdvWo79x1ZpAlumG//0JhAQEGyEBwUZIQLAREhBs+L6NNtOXnxSBDcftfFY+v08FV086wrszC/q0B3Cq6eejelroOgElxX3Nmj1jL2nj//A7PnVcOVkz9va1DKCKelvxvULrUdzsS1pNGeTOy2eateo/Yx+LqWH7/DxMyuhLCQAHRse6Xjl4DDWtogIxP4JShUCzv9nDTe3sXpBL4siGXmNskU3sWZjLMEu7v2lxc1AFGK5H1cyLV3sLCth/ZNaXjiUYJv13ILbbguAQZZp9PW9OZaBq+SJgU6hh55xLBqQBLT7uNqXUkv4iDwEeo468J0vF4HlABwyF8UJj3hO/BbLGgGB0esna0ekla4PNI4SBwL8097zsytbe2gAAAABJRU5ErkJggg==',
                symbolSize: this.chart.symbolSizeInDir,
                label: {
                  color: this.chart.lableColorInDir,
                  position: 'bottom',
                },
                category: 1,
              },
              {
                name: "发送文件夹",
                tooltip: {
                  formatter: this.chart.outdirTitle
                },
                symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAE4ElEQVRoge2Zf0zUZRzHX8/37kADiTA40xEnENhSK1PTtly6sqbmarqbm+VGEzWS+sNqbpScG7XVdC3XTLPEfrg2SFepJU5E+7Gl+IuxNFSE8wckJ+JhMH7c9z79cdwBeoenHAcWr7+e7+d5ns/zfn+fH3u++8IggwwySH+iwj3gnmV/iLd8tf6c0Vpo1T9P/94Xi6loM1qx6jlJX/lip+xDjIVY9Vnxa99H5HUlfLyr/s0cAC288gFwegux5pFmAIRL3ti19EizJyQ13lh6YrMFQIlkA1GiyPbW9YcBh7cguvE+AKWo9MbcIikACnXU105pCz0F1in4R0TWeeuMYRDcHaECRSqA5hF7RKAceAJA05gF/CqKrUqYA4BiZU7S13vfs7+cA+R0TdfNgGwmEY2PgJnAsCAFrVYZ2II2oDgKzAZwKzUbKFBKtouopQAiLMy3lKy2Vx8oaE9KXgFMBIaC7H3H8uWHLpf2TeWFyKpCrDp0WUId4o8D84IW7xGUK/nBGxDR9vq6CnNKbCXG8yNi9wG1HeFEd2Rjtg2bW4EVfPtjqIjKNRjkdFpSi8ubo3MPeN58XNDCb9OE80r178DFjse4ttoh82z7p7sQVnnbCJL3+QM/TMuzL6pSMBU4HChf10088zakdxKkCWuhVQc2+7oplXd4yWFTzKm2fIWUdoQj0PjuizHbp+bZF1WZ7GcfR8kCFDvoNN8xbAeyBcFkAnMCREeB1ncHVHtrNL8VrMHVPgSAtMnfkjS2iKYrd/Nj7nKar3pWsMGoS/z9lfmOk5Ney6ie3uIvV6eBrSYh2QIGQ58J70p1+SxOl1o9IjSdCc+tIW7ESeqrR7JnbYbPBIDBqNfpLuMW3OxSGmeGVbResl6/iTEnhE08QNJDRcQMrwZA3AbK92XR3JjAcEsNc1d/QnzKeV9b3WVIAHkbTQ4IcrExPcLPJo6OCpt48Lz18TPWY4psAqCtZRiHdr5Lw9/pRMU5eX7Vep5cvI277nH2nMdbkENjpKeGfYWzLpUjRW+ht0cCoBlcpD5WSOKDxWgGF+LWqD2RzM8fZH4KMh5IAUYsrnhBDQgDAI2XkygrfoOWps5TfGhMHakTtmEeXYpSbtTkv/xePAeEAYDW5ljKirNxOlK6xU2RTdybWEbN6akLECnTiKh95rOJvnU1YAyAZzPb/3yWquNzfUdsIGZumKKgPy5zPaA0Hcu4nxiV9gvnTjxNzalp3ZaV3z7ewkCYgesR0XA6kqm/OJazx1/coUTSRDCjiPXOwIA20JVAm7g/PmhCyqCB/qZPDGwsn8HG8hl9kfoGQn6MFtnHYzs4HwFGRTcwZ/SxUA/RjZDOwDGHhaUli9FFwy0ar5a8QumllJt37AUhM2BvjGfh7iya2yN8sVbdxEtFWVQ6zaEa5gZCYqChNYoFu5dzuSXmlupCQa8NtOgRN33L/mYnVPTKgFs0skoyglrnxxwWluzLRJfQHny9ypZ7cD47qx4Nuv2ec+OwHZzfmyFvIKR3oYRNG/zG6zKX9Tb1/+MudK3fVNycgF/2nQaUFIdFym2higLVdJ2BlSgawqDmVqnH3b4iUKXPgJpUUYEYH0apQqAxLNJ6phFUAW7XI2rKmQuBGoX0H1l85n6/J5lj01N99i/uP3UK3ZHc8QYG6W/+BQNpzcjS8B84AAAAAElFTkSuQmCC',
                symbolSize: this.chart.symbolSizeOutDir,
                label: {
                  color: this.chart.lableColorOutDir,
                  position: 'bottom',
                },
                value: [0, 450],
                x: 0,
                y: 450,
                fixed: true,
                category: 1,
              },
              {
                name: "传输接收队列",
                tooltip: {
                  formatter: this.chart.inqueTitle
                },
                symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAETUlEQVRoge2YW2wUZRiGn2+mXUBagbTbvZALXTwgVMAo0RC1B09caDAYiCQSo+2iaEwqmhjijReamAABIwfpkoYETAwiHmKCBMJuISC3EiGVYOGiMcC2JHKI3e7O/3nRNunOzmy37CwNcd+7/zv87/tmZr5/ZqCCCiooG+rbEx317YmOcnJIuTaub0u+LBY/ACKYlVfird+Xg6csBupiycUWJIDpI6FBQZ69Em86GTRX4AYibx2PGtv5DWjISSgDKvaS/vjT54Lks4Lc7J73jtQZ2zmIWzyAUCfiHIy8cyI/VwICMzD7g5PThoaqfgYe9C1SosbJ/BJZfWi6b80EEYyBT9VK38jsAZYUUb3YTJ3yLSv22UFQB2Ig/PexTaCvTqDlpfCsyMYguMs2RsOxpI5dp+LNZeEK9CGeDFQMTDYqBiYbd7yBqkLJGWuPz6rOZKJiWVFUoiIaNUpUlIupXc2xIIU0xBJ7FWsuaC9or6rVa4vpxanqvdz11AUQ9erLM1Af694h6JPAHLJOLWKBAiiqIJAxlr4fpHgAR/jMUj0NPAaCiGIQsB3Cse7rkPxLkVP98aa1Y/vybiFLNQUsAmq9iAS+Guhs6QnawEBnS4/AVp90LbBoRFsO8gxIVfVWYNBrFxWyqJwoSWkhOOaEoo5PNq0h3e4Oeh7v4TXJLpQ3fYmUX20xH12Kt565NaW5iLQlGo3IBoSlBcp2p+LNeZo8DUTaEo3GktN++RFkUbYT0k9S21tuTFAzMPIKfjP9MSrrFUKFasUyi67sbP09L+7XUB9LHhZ4bkzI4D12e9Qxr/R3tf5ZtHKgbk1iroX8iPKQR/oGUDO6UDjSH29+3msf33NAVDaPWX4naj0qcNSjdK7Y1qlIW6KxWPEN7ccWWCqnPMRnEd0WCmXvBfb7aMnV6U+j0hDr/kMhatv68KWvWy4CRNqPLjNibQAecDWcT0nNPDofzxRUv+JMKDwzdRaY45JyyLFk3dWdz5wd5um+z4ieBS6k4k3z/c6BAiexqFH5EmTjqHiAy7taf5qe0QWq7HA13F+vN1cWFA80zOh/zSU+qypvp+JNS0fFD/M0XUB1k6ps8RMP45zEU2ur96TT6bxPv4u7WwaBdxtiyZkKq0bjgr4AfFPYgr44diWin6fizZ2epSG+mDql2m+sAuMY6Nu85N+CWozZhmWtGhNZWLAeUOGR3D3sA361xUy30l7mxJx3RcLj9mhuzaBW9ZUioSQD2Wk17is0c9wmya2ZNnQ9XYqGkgzcVWXcE6e6iLacmsuDswtPrXFQkoG+vr4hV6iYfz25nPPnZUvRkHcObNl7IGdkdby+vGy/XorBeHru+C+yioHJxh1vwOskvgbcPbpwP0STCYF/3DGvK3DkNmi5VRx2B/IMOA7rgYHbImdiuOqovd4dzDPw4RvLzxknu1BhH8O302TjmsB+o/YT61Yvc797VVDB/x7/AYMUbgaWm75nAAAAAElFTkSuQmCC',
                symbolSize: this.chart.symbolSizeMQInQUE,
                label: {
                  color: this.chart.lableColorInQue,
                  position: 'bottom',
                },
                x: 1000,
                y: 300,
                value: [900, 150],
              },
              {
                name: "传输发送队列",
                tooltip: {
                  formatter: this.chart.outqueTitle
                },
                symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAEC0lEQVRoge1YXWwUVRT+zp3tdksQzLrTJoQXf1J/Y/skGKTd9cHEmEhEJSZqTGCnxCJYIEh48PfFGHkw0Rbsbh9MeKBCSI0makrYrQuKxsRg1EQsPPhEd5YCpSEwnbmHh7owO92dn7pl0zDf25x77jnfN/fec88MECLE7Q1aqMCqlmf7s55JLkgusRBBbyVCAY1GKKDRCAU0GqGARmPRC6jL9a5q+X4AvcEyc78+mHrj/+auywroF4vbAHzr15+Bo/oK9NUjd90arPjWk8siV6/+xMBDHhn/NhTl8Uv71l6oR966dohtGwv3SMX6GUCihssFhrK6lFl7ul455wgot8EEGMyYhECJmE8B9H3xojqMQw8bbgHVzWNdJHmUgahjyBTgpycyqaOujF78M9q6vPQSSD7FRB2QSBAhXo7nbMtrCqiBcSH5uYmh1B+uItJjm0CcdSTaUswkB9zmtaZ/eJRJHgFwby0fp4Cgh/g+KaiQ0Artbk56tnsIwE2yxP1e5O/qyT3AJAtwIV8N86lCdxKskZXbf2xxcypXJj8VZ0XPr0sEaATAsqBk5gjQM0laHrsSMyJKXDFFK4HWADjocHvw2uWZd1wjH9pgGRHl5ZmIsgHvpUw3V4On3wXjfpvJJOADErIzGjUTRkSJ65luUe2z1HcVSqTzA0R43WaasYTonPy86y+/MaqhbVPuESnoNwCRso2ZNpey3YN+5vveQktN3gHgH5upSZFyb/khoRXaVS3/hVecVi13ILHx2I23LYk+ho08GN/5JQ8EvAfa0sfWSRIjFQGYnmeSjwHUR8CpYia5yi2GquV/AdBJwGew5AlWxGHbsGkJ0RFkVQMd4onsk18BGLXbmHAQoN0AmsEY94pBwDiAJga2s0LDjtH9Qbdk4CpEQu4CIG9auMnGzlNApUhSbCPTTSTfD8onkIB4OrdSSrET4OrzmM54xWBR02fpDNO+tvTY3UE4RbxdZuu0ictvMdNuALGaR4ctTwFkWeMsar63F5j4WTWd32+1xN6e/HT1lFc8XyuwpLloQYqzDLgTJOm5hbjZfZUY+BdEZ2PXIq53x42UfpzsUHtyT2B2JZ5xzJ/WM8k7fMXQ8lMAHL50giV/VBrq/gYgt36sAr62kB36YOo4gOMJrdBObG0BQQPQAqq4I7xwBrOl1JDAsGCxt5jt+j0oF2AeAsr4r6d/U+3NfUgG9UqQ6ncug04K5q85ygOlgdS5+XIAqmyhTw4cqVi+vlfWL9gveD/w4rPo/0qEAhqNRS+gWhWagu3LyHmIGgkCLjlt1VbA/a9BYzHqNMwRYFnYA+D8LaETDJMWK3ucxjkCdr62/rS0zA4GvsTsdmo0pgg4LFlZtePVdd7teogQtxmuAy4HZFqvXfPmAAAAAElFTkSuQmCC',
                symbolSize: this.chart.symbolSizeMQOutQUE,
                label: {
                  color: this.chart.lableColorOutQue,
                  position: 'bottom',
                },
                x: 1000,
                y: 400,
                value: [900, 450],
                fixed: true,
                category: 2
              },
            ],
            links: [{
              source: "数据交换客户端",
              target: "接收文件夹",
              lineStyle: {
                normal: {
                  color: this.chart.lineColorInDir_Client,
                }
              },
            },
              {
                source: "发送文件夹",
                target: "数据交换客户端",
                lineStyle: {
                  normal: {
                    color: this.chart.lineColorOutDir_Client,
                  }
                }
              },
              {
                source: "传输接收队列",
                target: "MQ",
                lineStyle: {
                  normal: {
                    color: this.chart.lineColorMQ_InQ,
                  }
                }
              },
              {
                source: "MQ",
                target: "数据交换客户端",
                lineStyle: {
                  normal: {
                    color: this.chart.lineColorClient_InMQ,
                  }
                }
              },
              {
                source: "数据交换客户端",
                target: "MQ",
                lineStyle: {
                  normal: {
                    color: this.chart.lineColorClient_OutMQ,
                  }
                }
              },
              {
                source: "MQ",
                target: "传输发送队列",
                lineStyle: {
                  normal: {
                    color: this.chart.lineColorMQ_OutQ,
                  }
                }
              },
            ],

            lineStyle: {
              normal: {
                opacity: 1,
                color: "#53B5EA",
                curveness: 0.2,
                // 12b5d0
                // type: "dashed",
                width: 2
              }
            }
          },
            {
              type: "lines",
              coordinateSystem: "cartesian2d",
              z: 1,
              zlevel: 2,
              animation: false,
              effect: {
                show: this.chart.linePointShow,
                period: this.chart.ontPeriod, // 移动速度
                trailLength: 0.01, // 点的长度
                symbolSize: 12, // 点的大小
                symbol: "pin",
                loop: true,
                color: "rgba(55,155,255,0.5)"
              },
              lineStyle: {
                normal: {
                  color: "#22AC38",
                  width: 0,
                  curveness: 0.2
                }
              },
              data: [
                // 客户端-接收文件夹
                {coords: [[300, 300], [0, 150]]},
                // 客户端-MQ
                {coords: [[300, 300], [600, 300]]},
                // MQ-客户端
                {coords: [[600, 300], [300, 300]]},
                // 发送文件夹-客户端
                {coords: [[0, 450], [300, 300]]},
                // 接收队列-MQ
                {coords: [[900, 150], [600, 300]]},
                // MQ-发送队列
                {coords: [[600, 300], [900, 450]]},
              ]
            },
            {
              type: "lines",
              coordinateSystem: "cartesian2d",
              z: 1,
              zlevel: 2,
              animation: false,
              effect: {
                show: this.chart.linePointShow,
                period: this.chart.twoPeriod,
                trailLength: 0.01,
                symbolSize: 12,
                symbol: "pin",
                loop: true,
                color: "rgba(55,155,255,0.5)"
              },
              lineStyle: {
                normal: {
                  color: "#22AC38",
                  width: 0,
                  curveness: 0.2
                }
              },
              data: [
                // 客户端-接收文件夹
                {coords: [[300, 300], [0, 150]]},
                // 客户端-MQ
                {coords: [[300, 300], [600, 300]]},
                // MQ-客户端
                {coords: [[600, 300], [300, 300]]},
                // 发送文件夹-客户端
                {coords: [[0, 450], [300, 300]]},
                // 接收队列-MQ
                {coords: [[900, 150], [600, 300]]},
                // MQ-发送队列
                {coords: [[600, 300], [900, 450]]},
              ]
            },
          ]
        });
      },
      pointShow(){
        if (this.sqps > 0 || this.pqps > 0) {
          this.chart.linePointShow = true;
        } else {
          this.chart.linePointShow = false;
        }
        this.drawLine();
      },
      // 环境信息检测 右侧信息显示
      environmentalTesting() {
        this.activities = [{
          content: "★★★★★★★★★★环境检测开始★★★★★★★★★★",
        }]
        this.drawer = true;
        EasyConfigApi.environmentalTestingLocal().then(resp => {
          let results0 = resp.result;
          results0.infos.forEach(value => {
            this.activities.push({
              content: value,
            });
          });
          // 本地检测成功 再去检测其他
          if (results0.result === true) {
            EasyConfigApi.environmentalTestingDir().then(resp => {
              let results1 = resp.result;
              results1.infos.forEach(value => {
                this.activities.push({
                  content: value,
                });
              });
            }).then(() => {
              EasyConfigApi.environmentalTestingClient().then(resp => {
                let results2 = resp.result;
                results2.infos.forEach(value => {
                  this.activities.push({
                    content: value,
                  });
                });
              })
            }).then(() => {
              EasyConfigApi.environmentalTestingMQ().then(resp => {
                let results3 = resp.result;
                results3.infos.forEach(value => {
                  this.activities.push({
                    content: value,
                  });
                });
                if (results3.result === true) {
                  EasyConfigApi.environmentalTestingQue().then(resp => {
                    let results4 = resp.result;
                    results4.infos.forEach(value => {
                      this.activities.push({
                        content: value,
                      });
                    });
                  })
                }
              })
            });
          }
        });
      },
      // 清除定时任务
      clearInterfval() {
        clearInterval(this.t1);
        clearTimeout(this.t2);
      },
      //基础环境检测
      basicsEnvironmentalTesting() {
        this.initSizeData();// 初始化大小
        this.inittitleData();// 初始化显示
        this.clearInterfval();// 清除定时任务
        this.drawLine()
        EnvironmentApi.queryBasicsStatus().then(resp => {
          this.localData = resp.localData;
          this.transData = resp.transData;
          // 新建定时任务 闪烁图标 变换显示
          this.t1 = setInterval(() => {
            // 客户端闪烁
            if(this.exceptions>0||this.blocknum>0){
              this.chart.symbolSizeClient = [110, 85]
              this.chart.clientTitle = "系统异常：" + this.exceptions + "; 阻塞异常：" + this.blocknum
            }
            // 接收目录
            if (!this.localData.pdstat) {
              this.chart.symbolSizeInDir = [80, 65]
              this.chart.indirTitle = this.localData.pdinfo;
            }
            // 发送目录
            if (!this.localData.csstat) {
              this.chart.symbolSizeOutDir = [80, 65]
              this.chart.outdirTitle = this.localData.csinfo;
            }
            // MQ
            if(!this.transData.connstat){
              this.chart.symbolSizeMQ = [90, 60]// MQ大小
              this.chart.mqTitle = this.transData.conninfo;
            }
            // 接收队列
            if(!this.transData.csstat){
              this.chart.symbolSizeMQInQUE = [90, 55]// MQQUE大小
              this.chart.inqueTitle = this.transData.csinfo
            }
            // 发送队列
            if(!this.transData.pdstat){
              this.chart.symbolSizeMQOutQUE = [90, 55]// MQQUE大小
              this.chart.outqueTitle = this.transData.pdinfo
            }
            this.drawLine()
            this.t2 = setTimeout(() => {
              this.initSizeData();
              this.drawLine()
            }, 500)
          }, 1000)
        });
      },
      initSizeData() {
          this.chart.symbolSizeOutDir = [60, 50]// 文件夹大小
          this.chart.symbolSizeInDir = [60, 50]// 文件夹大小
          this.chart.symbolSizeClient = [90, 70]// 客户端大小
          this.chart.symbolSizeMQ = [80, 50]// MQ大小
          this.chart.symbolSizeMQInQUE = [70, 40]// MQQUE大小
          this.chart.symbolSizeMQOutQUE = [70, 40]// MQQUE大小
      },
      inittitleData() {
        this.chart.clientTitle = "运行正常"
        this.chart.mqTitle = "运行正常"
        this.chart.inqueTitle = "运行正常"
        this.chart.outqueTitle = "运行正常"
        this.chart.indirTitle = "运行正常"
        this.chart.outdirTitle = "运行正常"
      },
      // 客户端异常图形绘制
      handleDrawerClose(done) {
        this.drawer = false;
      },
      //--------------WebSocket----------------------------
      initWebSocket() {
        this.websocketonmessage();
        this.notification();
      },
      websocketonmessage() {
        let wsuri_;
        if (process.env.NODE_ENV === 'production') {
          wsuri_ = `ws://${config.context.domain}:${config.context.port}/asestatus`;
        } else {
          wsuri_ = `ws://localhost:9099/asestatus`;
        }
        // const wsuri = "ws://" + this.host + ":" + this.port + "/asestatus";
        // const wsuri = "ws://127.0.0.1:9099/asestatus";
        const wsuri = wsuri_;
        this.websock = new WebSocket(wsuri);
        // this.websock.onopen = function(e) {
        this.websock.onmessage = function (e) {
          // 数据接收
          const redata = JSON.parse(e.data);
          if (redata.wstype === "ws01") {
            this.sqps = redata.sqps;
            this.pqps = redata.pqps;
            if (this.DataMgr.chartData.rows.length > 9) {
              // 10次以上执行清除
              this.DataMgr.chartData.rows.splice(0, 1);
            }
            this.DataMgr.chartData.rows.push({
              时间: new Date().toLocaleTimeString().replace(/^\D*/, ""),
              "接收(票)": redata.sqps,
              "发送(票)": redata.pqps
            });
            if (this.flowMgr.chartData.rows.length > 9) {
              // 10次以上执行清除
              this.flowMgr.chartData.rows.splice(0, 1);
            }
            this.flowMgr.chartData.rows.push({
              时间: new Date().toLocaleTimeString().replace(/^\D*/, ""),
              "接收(M)": (redata.scps / 1024 / 1024).toFixed(2),
              "发送(M)": (redata.pcps / 1024 / 1024).toFixed(2)
            });
          }
        }.bind(this);
        this.websock.onclose = this.websocketclose;
      },
      notification() {
        let wsurl_;
        if (process.env.NODE_ENV === 'production') {
          wsurl_ = `ws://${config.context.domain}:${config.context.port}/asemonitor`;
        } else {
          wsurl_ = `ws://localhost:9099/asemonitor`;
        }
        // const wsurl = "ws://" + this.host + ":" + this.port + "/asemonitor";
        // const wsurl = "ws://127.0.0.1:9099/asemonitor";
        const wsurl = wsurl_;
        this.notice = new WebSocket(wsurl);
        this.notice.onmessage = function (e) {
          const redata = JSON.parse(e.data);
          if (redata.wstype === "ws07") {
            if (redata.errors > 0) {
              this.exceptions = redata.errors;
            } else {
              this.exceptions = 0;
            }
            if (redata.blocks > 0) {
              this.blocknum = redata.blocks;
            } else {
              this.blocknum = 0;
            }
          } else if (redata.wstype === "ws09") {
            if (redata.dxpreswarn > 0) {
              this.warnnum = redata.dxpreswarn;
            } else {
              this.warnnum = 0;
            }
          }
        }.bind(this);
        this.notice.onclose = this.websocketclose;
      },
      websocketclose(e) {
        // 关闭
        console.log("connection closed (" + e.code + ")");
      }
    },
  };
</script>
<style>
  .el-drawer__open .el-drawer.ltr {
    overflow: scroll;
  }
</style>